var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"t-page_dialog t-work-area"},[_c('h1',[_vm._v(_vm._s(_vm.pageText.title)+" "),(_vm.mobileState && _vm.$route.query.sel && _vm.$route.query.sel !== 'all')?_c('span',{on:{"click":function($event){$event.preventDefault();return _vm.CloseDialog()}}},[_vm._v(_vm._s(_vm.pageText.subtitle))]):_vm._e()]),_vm._v(" "),_c('cmp-dialog')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27e03ed4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue_pages/Dialog/Index.vue
// module id = 383
// module chunks = 0